// Create campaign batches
export const createCampaignBatches = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.lc}/create-compaign-batches`,
    payload,
    true
  );
};
import apiClient from 'utilities/apiClient';

export const materials = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.materialList}/${url}`, payload, true);
};

export const materialsMRNS = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.document}/${url}`, payload, true);
};

export const create_materials = (url, payload) => {
  return apiClient.post(
    `${apiClient.Urls.document}/${url}`,
    payload,
    true,
    'file'
  );
};

export const create_invoice = (url, payload) => {
  return apiClient.patch(
    `${apiClient.Urls.document}/${url}?id=${payload.document_id}`,
    payload,
    true
  );
};

export const create_vehicles = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.vehicle}/${url}`, payload, true);
};

export const create_weighing = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.weighing}/${url}`, payload, true);
};

export const create_damaged = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.damaged}/${url}`, payload, true);
};

export const suppliers = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.supplierslist}/${url}`, payload, true);
};

export const qc = (url, payload) => {
  return apiClient.post(
    `${apiClient.Urls.qc}/${url}?id=${payload.id}`,
    payload,
    true
  );
};

export const print = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.printLable}/${url}`, payload, true);
};
export const documents = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.document}/${url}`, payload, true);
};

export const netweights = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.weighing}/${url}`, payload, true);
};

export const updatenetweights = (url, payload) => {
  return apiClient.patch(`${apiClient.Urls.weighing}/${url}`, payload, true);
};

export const dispensingList = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.dispense}/${url}`, payload, true);
};

export const batch = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.batch}/${url}`, payload, true);
};

export const dispense = (url, payload) => {
  return apiClient.patch(`${apiClient.Urls.dispense}/${url}`, payload, true);
};

export const batchDetails = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.transfer}/${url}`, payload, true);
};

export const createCodetransfer = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.transfer}/${url}`, payload, true);
};

export const getCodetoCodeTransferData = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.transfer}/${url}`, payload, true);
};

export const approvedData = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.transfer}/${url}`, payload, true);
};

export const update = (url, payload) => {
  return apiClient.patch(`${apiClient.Urls.weighing}/${url}`, payload, true);
};

export const typedMaterials = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.transfer}/${url}`, payload, true);
};
export const regenerateCodeTransferLabels = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.transfer}/${url}`, payload, true);
};
export const dispensing = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.dispense}/${url}`, payload, true);
};
export const purchase = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.purchase}/${url}`, payload, true);
};

export const deleteDoc = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.document}/${url}`, payload, true);
};

export const regenerateMRN = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.batch}/${url}`, payload, true);
};

export const generateMaterialPdf = (id) => {
  return apiClient.get(
    `${apiClient.Urls.document}/generate-material-pdf/${id}`,
    {},
    true
  );
};

// Material Receipt label print/reprint with QA approval.
// Payload shape:
//   { batch_details_id, employee_id?, password?, comments? }
// First call should omit QA credentials. The backend will either:
//   - return data.requires_approval=true (caller must open the QA modal and
//     repeat the request with creds), OR
//   - return data.pdf_url for an original print.
export const requestMaterialLabelPrint = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.materialLabel}/print-request`,
    payload,
    true
  );
};

export const reGenerateQrLabels = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.batch}/${url}`, payload, true);
};
